import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <a
      href={`/article/${movie.id}`}
      className="group block cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.REACT_APP_NAVIGATE(`/article/${movie.id}`);
      }}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={movie.imageUrl}
          alt={`${movie.title} - 八戒影院免费在线观看`}
          title={`${movie.title} - 高清免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {movie.isNew && (
          <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap">
            NEW
          </div>
        )}
        
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 text-accent-400 text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px]"></i>
          </div>
          {movie.rating}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-2">
            {movie.description}
          </p>
        </div>
      </div>
      
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1 flex-wrap">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500">{movie.genre.slice(0, 2).join('/')}</span>
        </div>
      </div>
    </a>
  );
}